import { css } from 'lit';

export default css`
  :host(.advt-x) {
    display: none;
    position: relative;
    z-index: 2;
  }

  :host(.advt-g) {
    margin: 0 auto;
    overflow: hidden;
    grid-column: 1 / -1;
    width: 100%;
    min-height: 10px;
  }

  :host(.banner-ad[placementid*='advt_recirc_middle_2']),
  :host([placementid*='advt_middle']) {
    margin: 0 auto;
    overflow: hidden;
    grid-column: 1 / -1;
  }

  :host([placementid='advt_top_2']) {
    width: 100%;
    min-height: 50px;
    margin: 12px 0;
    overflow: hidden;
  }

  /* Handle 5 rows banner ad in recirc placement 1 */
  :host(.banner-ad[placementId='advt_recirc_middle_1']) {
    grid-column: 1 / 3;
  }

  :host([placementid='advt_bottom_1']) {
    overflow: visible;
    margin: 20px 0;
  }

  :host([placementid='advt_bottom_1']) #advt_bottom_1 {
    margin-left: auto;
  }

  :host([placementid*='advt_recirc_middle_']) #advt_bottom_1 {
    width: 100%;
  }

  :host(.video-ad[placementid*='advt_recirc_middle_']) {
    margin: 0 auto;
    grid-column: 1 / -1;
  }

  :host(.native-ad[placementid*='middle_']) {
    grid-column: unset;
    overflow: visible;
  }

  @media (max-width: 989px) {
    :host(.banner-ad[placementid*='advt_recirc_middle_1']) {
      margin: 0 auto;
      overflow: hidden;
      grid-column: 1 / -1;
    }
  }

  :host(.loaded) {
    display: block;
  }
  :host(.hidden) {
    display: none;
  }
`;
